import { OrderEntity } from '@genial/services';

export const checkOrderIsEquity = (item: OrderEntity) => {
  return item.marketType === 'Renda Variável';
};

export const checkOrderIsDirectTreasury = (item: OrderEntity) => {
  return item.marketType === 'Tesouro Direto';
};

export const checkOrderIsStructuredProduct = (item: OrderEntity) => {
  return item.marketType === 'Op. Estruturadas';
};

export const checkOrderIsFundProduct = (item: OrderEntity) => {
  return item.marketType === 'Fundos';
};

export const checkOrderIsFixedIncomeProduct = (item: OrderEntity) => {
  return item.marketType === 'Renda Fixa';
};
